var i = /* @__PURE__ */ ((c) => (c[c.Local = 0] = "Local", c[c.Session = 1] = "Session", c[c.Cookie = 2] = "Cookie", c[c.Secret = 3] = "Secret", c))(i || {});
export {
  i as Storages
};
